module.exports = __webpack_public_path__ + "static/Dickenson_Logo_Stacked-404e4dc3f7a39c68f55e46f2f81ce41b.png";